// extracted by mini-css-extract-plugin
export default {"reactions":"Reactions_reactions__q21Le"};